import React from 'react';
import { ArrowRightIcon, LockIcon, DownloadIcon, InfinityIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
const trust = [{
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: CreditCardIcon,
  label: 'Stripe approved'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
const meta = [{
  icon: InfinityIcon,
  label: 'One-time payment · Lifetime access'
}, {
  icon: LockIcon,
  label: '100% secure payment'
}, {
  icon: DownloadIcon,
  label: 'Immediate digital download'
}];
export function PriceOffer() {
  return <div id="offer" className="mx-auto max-w-3xl scroll-mt-8 rounded-2xl border border-brand-gold/30 bg-navy-900 p-6 text-center shadow-2xl sm:p-8" data-id="element-114" data-mp="2w9xe9bbb60ry">
      <div className="overflow-hidden rounded-xl border border-white/10 shadow-2xl" data-id="element-115" data-mp="319tjfdvqry93">
        <img src="https://cdn.magicpatterns.com/uploads/6vCQHvuwre57PFkVP21XN8/comprimida-final.png" alt="Real estate agent celebrating a closed deal in a modern city office" className="h-40 w-full object-cover sm:h-52" width={1200} height={900} loading="lazy" style={{
        width: "261px",
        height: "286px"
      }} data-id="element-116" data-mp="bin4v8oaiw1e" />
      </div>

      <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-117" data-mp="3q9a90krhuki2">
        {trust.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-1.5 text-xs font-semibold text-slate-400" data-id="element-118" data-mp="3ge02bjq5hoxy">
            <Icon aria-hidden="true" className="h-4 w-4 text-brand-gold" data-id="element-119" data-mp="3bf5mmqnhcgi2" />
            {label}
          </li>)}
      </ul>

      <div className="mt-6 flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1" data-id="element-120" data-mp="36ludujz3xpni">
        <span className="text-5xl font-black leading-none tracking-tight text-brand-gold sm:text-6xl" style={{
        color: "#FFF200"
      }} data-id="element-121" data-mp="32mllnjjptzu2">
          21   <span className="text-2xl align-top sm:text-3xl" data-id="element-122" data-mp="2snmigghpyweg">USD</span>
        </span>
        <span className="text-lg font-semibold text-slate-400 line-through decoration-slate-500 sm:text-xl" data-id="element-123" data-mp="2spgvl8mr1k7z">
          129 USD
        </span>
      </div>

      <p className="mt-3 text-sm font-semibold text-white" data-id="element-124" data-mp="2dzvwzf4wycbk">5 volumes + 5 bonuses included (800+pages)</p>

      <a href="https://the-real-estate-growth-system.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
      value: 24,
      currency: 'USD'
    })} className="group mt-6 inline-flex w-full items-center justify-center gap-3 rounded-lg bg-brand-gold px-6 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-navy-900 shadow-cta transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-goldDark hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold active:translate-y-0 sm:w-auto sm:text-base" style={{
      fontSize: "18px",
      fontWeight: "900",
      fontFamily: "Avenir, sans-serif",
      backgroundColor: "#FFF200",
      backgroundImage: "none"
    }} data-id="element-125" data-mp="2j0th3x9hhgfp">
        YES! I WANT THE COMPLETE SYSTEM FOR JUST 21 USD
        <ArrowRightIcon aria-hidden="true" className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" data-id="element-126" data-mp="191r1dx01t5x9" />
      </a>

      <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-127" data-mp="140uvjdw4z9p7">
        {meta.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-1.5 text-[13px] font-medium leading-tight text-slate-300" data-id="element-128" data-mp="1dsh2uz5csomo">
            <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-129" data-mp="q3xvclu4ofvn" />
            {label}
          </li>)}
      </ul>

      <p className="mt-3 text-center text-[12px] leading-snug text-slate-400" data-id="element-130" data-mp="l667q40infx9">
        Instant access · 7-day guarantee · Join <span className="font-semibold text-slate-200" data-id="element-131" data-mp="v298p6jmt8im">2,000+ agents</span> who&rsquo;ve already transformed their business.
      </p>
    </div>;
}